import { CookiesStorageService } from '@/services/cookiesStorageService';
import { COOKIES_KEYS } from '@/constants';

export interface SplitTestEntry {
	id: string;
	variation: string;
}

export type SplitTestsCookieValue = Record<string, SplitTestEntry>;

/**
 * Read the split tests cookie. Returns a map of test name -> { id, variation }.
 * Different tests are stored independently so a user can be in different variations
 * across multiple concurrent tests without conflicts.
 */
export const getSplitTests = (): SplitTestsCookieValue => {
	return CookiesStorageService.get<SplitTestsCookieValue>(
		COOKIES_KEYS.SPLIT_TESTS,
		{},
	);
};

/**
 * Get the variation for a single test by name. Returns undefined if the user
 * has not been assigned to that test yet.
 */
export const getSplitTestVariation = (testName: string): string | undefined => {
	return getSplitTests()[testName]?.variation;
};
